export const redirectOnLoader = (location = '/') => {
  return {
    isRedirect: true,
    location: location,
  };
};
